/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { BaseNotification } from '../../notifications-data-instances';
import { BaseNotificationComponent, INotificationElementProps } from './base-notification-component';

/**
 * Represents the component which composes the body of a notification.
 */
export class NotificationContent<NotificationType extends BaseNotification> extends BaseNotificationComponent<
    NotificationType,
    INotificationElementProps<NotificationType>
> {
    /**
     * The class for the styles.
     */
    public static readonly className: string = 'msc-notification-content';

    public constructor(props: INotificationElementProps<NotificationType>) {
        // Disable jest test coverage due to the issue in jest processing super calls.
        /* istanbul ignore next */
        super(props);
    }

    public render(): React.ReactNode {
        return <div className={NotificationContent.className}>{this.props.children}</div>;
    }
}
